export default __webpack_public_path__ + "static/media/nephron-sponsor-logo.b1097c51.png";